import { render, staticRenderFns } from "./FrequenciesReport.vue?vue&type=template&id=55890eed&scoped=true&"
import script from "./FrequenciesReport.vue?vue&type=script&lang=js&"
export * from "./FrequenciesReport.vue?vue&type=script&lang=js&"
import style0 from "./FrequenciesReport.vue?vue&type=style&index=0&id=55890eed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55890eed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VForm,VRow,VTooltip})
